import shy from "src/lib/shy";
import { PartialSchemaReference } from "src/lib/schemaOrgUrl";

const FormattedSchemaPath = ({ name, namespace }: PartialSchemaReference) => (
  <>
    <span className="light-namespace">@{namespace}/</span>
    <span>{shy(name)}</span>
  </>
);

export default FormattedSchemaPath;
